import { MAX_CONTACT_ATTEMPTS, NOT_REACHED_REMINDER_DAYS } from "@myapp/contract";

const DAY_MS = 24 * 60 * 60 * 1000;

export type AttemptsSummary = {
  count: number;
  max: number;
  /** Attempts still allowed, never below 0. */
  remaining: number;
  /** All attempts used — the office may now set „Gelöscht". */
  isFull: boolean;
  /** Whole days since the Auftrag became „Nicht erreicht"; null when it has no episode. */
  daysSince: number | null;
  /** Whole days until the 3-week reminder; 0 once it is due; null without an episode. */
  remindInDays: number | null;
};

/**
 * The numbers the „Kontaktversuche" card and the list chip show. Pure, so the day arithmetic is
 * tested without rendering: „seit N Tagen" counts from `notReachedSince`, not from the first
 * attempt, because that is what the 3-week reminder counts from too.
 */
export function getAttemptsSummary(input: {
  count: number;
  notReachedSince: string | null;
  now: Date;
}): AttemptsSummary {
  const { count, notReachedSince, now } = input;
  const since = notReachedSince ? new Date(notReachedSince) : null;
  const daysSince =
    since && !Number.isNaN(since.getTime())
      ? Math.max(0, Math.floor((now.getTime() - since.getTime()) / DAY_MS))
      : null;

  return {
    count,
    max: MAX_CONTACT_ATTEMPTS,
    remaining: Math.max(0, MAX_CONTACT_ATTEMPTS - count),
    isFull: count >= MAX_CONTACT_ATTEMPTS,
    daysSince,
    remindInDays: daysSince === null ? null : Math.max(0, NOT_REACHED_REMINDER_DAYS - daysSince),
  };
}
